<div *ngIf="!loadingData">
    <app-spinner></app-spinner>
</div>

<div *ngIf="loadingData">
    
    <app-component-selector 
        [campusId]="this.edition.campusId" 
        [editionId]="this.edition.editionId"
        [webResourceId]="this.webResourceId">
    </app-component-selector>

    <div class="container p-3" *ngIf="!courses || courses.length === 0">

        <div class="alert alert-primary h-100 mx-auto mb-3">
            <div class="card-body">
                <span>No hay cursos que mostrar para esta edición del campus</span>
            </div>
        </div>

    </div>

    <div *ngIf="courses && courses.length > 0">

        <div class="container mt-3">
        
            <div class="row w-100 mx-0 d-flex flex-row justify-content-end align-items-center">
                
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 px-0">
                    <mat-form-field appearance="outline" class="w-100 px-0">
                        <mat-label>Buscar por curso o área</mat-label>
                        <input matInput [(ngModel)]="filterValues.searchText" (input)="filterCourses()">
                        <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                </div>
                
            </div>
            
            <div class="row w-100 mx-0 mb-2 d-flex flex-row justify-content-start align-items-center" *ngIf="areas.length > 1">
                
                <div class="col-12 col-sm-12 col-md-12 col-lg-1 col-xl-1 col-xxl-1">
                    <h4>Áreas: </h4>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 col-xxl-11">
                    <mat-chip-list aria-label="area-selection" selectable multiple>
                        <mat-chip *ngFor="let area of areas" 
                            class="d-flex flex-row justify-content-start align-items-center"
                            [value]="area.areaId"
                            [selected]="filterValues.areas[area.areaId]" 
                            (selectionChange)="filterCourses()"
                            (click)="filterValues.areas[area.areaId] = !filterValues.areas[area.areaId]">
                                <img  *ngIf="getAreaIconPath(area) !== null" class="align-self-center me-2 h-100" [src]="getAreaIconPath(area)">
                                <span class="align-self-center">{{ area.name }}</span>
                        </mat-chip>
                    </mat-chip-list>
                </div>
        
            </div>

            <!-- <div class="row w-100 mx-0 mb-2 d-flex flex-row justify-content-start align-items-center" *ngIf="languages.length > 1">
                
                <div class="col-12 col-sm-12 col-md-12 col-lg-1 col-xl-1 col-xxl-1">
                    <h4>Idiomas: </h4>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 col-xxl-11">
                    <mat-chip-list aria-label="language-selection" selectable multiple>
                        <mat-chip *ngFor="let language of languages" 
                            class="d-flex flex-row justify-content-start align-items-center"
                            [value]="language.languageId"
                            [selected]="filterValues.languages[language.languageId]" 
                            (selectionChange)="filterCourses()"
                            (click)="filterValues.languages[language.languageId] = !filterValues.languages[language.languageId]">
                                <img  *ngIf="language.iconPath" class="align-self-center me-2 h-100" [src]="language.iconPath">
                                <span class="align-self-center">{{ language.name }}</span>
                        </mat-chip>
                    </mat-chip-list>
                </div>
        
            </div> -->

            <div class="row w-100 mx-0 mb-2 d-flex flex-row justify-content-start align-items-center" *ngIf="classifications.length > 1">
                
                <div class="col-12 col-sm-12 col-md-12 col-lg-1 col-xl-1 col-xxl-1">
                    <h4>Niveles: </h4>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 col-xxl-11">
                    <mat-chip-list aria-label="classification-selection" selectable multiple>
                        <mat-chip *ngFor="let classification of classifications" 
                            class="d-flex flex-row justify-content-start align-items-center"
                            [value]="classification.classificationId"
                            [selected]="filterValues.classifications[classification.classificationId]" 
                            (selectionChange)="filterCourses()" 
                            (click)="filterValues.classifications[classification.classificationId] = !filterValues.classifications[classification.classificationId]">
                            <img  *ngIf="classification.iconPath" class="align-self-center me-2 h-100" [src]="classification.iconPath">
                            <span class="align-self-center">{{classification.name}}</span>
                        </mat-chip>
                    </mat-chip-list>
                </div>
        
            </div>
                
        </div>
        
        <div class="container p-3" *ngIf="filteredCourses && filteredCourses.length > 0">
            <app-course-summary-card [edition]="edition" [course]="course" *ngFor="let course of filteredCourses"></app-course-summary-card>  
        </div>

        <div class="container p-3" *ngIf="!filteredCourses || filteredCourses.length === 0">

            <div class="card h-100 mx-auto mb-3">
                <div class="card-body">
                    <span>No hay cursos que mostrar</span>
                </div>
            </div>

        </div>

    </div>

</div>
